import { Column, Loading, Row } from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Card from "../../components/Card/Card";
import http from "../../http-common";
import { PieChart, StackedBarChart } from "@carbon/charts-react";

const pieChartOptions = {
  title: "",
  resizable: true,
  legend: {
    alignment: "center",
  },
  pie: {
    alignment: "center",
  },
  height: "200px",
};

const pieChartOptions1 = {
  title: "",
  resizable: true,
  legend: {
    alignment: "center",
  },
  pie: {
    alignment: "center",
  },
  height: "400px",
};

const barChartOptions = {
  title: "",
  axes: {
    left: { mapsTo: "value" },
    bottom: { mapsTo: "group", scaleType: "labels" },
  },
  height: "400px",
};

const options = {
  title: "",
  axes: {
    left: {
      mapsTo: "value",
      stacked: true,
    },
    bottom: {
      mapsTo: "key",
      scaleType: "labels",
    },
  },
  height: "400px",
};
const DashboardPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [stats, setStats] = useState({});
  const [candidaturesByGender, setCandidaturesByGender] = useState([]);
  const [candidaturesByProvince, setCandidaturesByProvince] = useState([]);

  const getStats = async () => {
    try {
      const response = await http.get("/stats");
      setStats(response.data);
      setCandidaturesByGender(response.data.candidaturesByGender);
      setCandidaturesByProvince(response.data.candidaturesByProvince);
      setIsLoading(false);
    } catch (error) {
      toast.error("Erro ao carregar dados estatísticos");
    }
  };

  useEffect(() => {
    getStats();
  }, []);

  return (
    <>
      <h3>Dashboard</h3>
      <Loading
        active={isLoading}
        description="Active loading indicator"
        withOverlay={true}
      />
      <div className="dashboard">
        <Row>
          <Column xsm={12} sm={12} lg={12} xlg={12}>
            <Card title="Candidaturas">
              <table className="table table-borderless text-center">
                <tr>
                  <td>
                    <p>Total</p>
                    <h1>{stats.totalCandidatures}</h1>
                  </td>
                  <td>
                    <p>Submetidas</p>
                    <h1>{stats.totalSubmittedCandidatures}</h1>
                  </td>
                  <td>
                    <p>Elegiveis</p>
                    <h1>{stats.totalEligibleCandidatures}</h1>
                  </td>
                  {/* <td>
                    <p>Elegiveis</p>
                    <h1>{stats.totalEligibleCandidatures}</h1>
                  </td>
                  <td>
                    <p>Apuradas</p>
                    <h1>{stats.totalQualifiedCandidatures}</h1>
                  </td> */}
                </tr>
              </table>
            </Card>
          </Column>
          {/* <Column xsm={12} sm={12} lg={6} xlg={6}>
            <Card title="Candidaturas por Forma Legal">
              <PieChart
                data={candidaturesByGender}
                options={pieChartOptions}
              ></PieChart>
            </Card>
          </Column> */}
        </Row>
        {/* <Row className="mt-2">
          <Column>
            <Card title="Candidaturas Por localização da Sede">
              <StackedBarChart
                data={candidaturesByProvince}
                options={options}
              ></StackedBarChart>
            </Card>
          </Column>
        </Row> */}
      </div>
    </>
  );
};

export default DashboardPage;
